var React = require('react');

function Telegram (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.7198 2.60447L18.4658 17.9499C18.2204 19.033 17.5801 19.3025 16.6703 18.7924L11.7125 15.1388L9.32026 17.4398C9.05555 17.7045 8.83407 17.9259 8.32388 17.9259L8.68004 12.8765L17.869 4.57317C18.2685 4.21702 17.7824 4.01963 17.248 4.37583L5.88826 11.5287L0.99774 9.99802C-0.0660413 9.66586 -0.0852601 8.93419 1.21913 8.424L20.3479 1.05455C21.2335 0.722438 22.0086 1.25184 21.7198 2.60447Z","fill":"#797199"}));
}

Telegram.defaultProps = {"width":"22","height":"20","viewBox":"0 0 22 20","fill":"none"};

module.exports = Telegram;

Telegram.default = Telegram;
